import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaSair.vue?vue&type=template&id=01468952&scoped=true"
import script from "./ModalSolicitacaoCirurgiaSair.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaSair.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaSair.vue?vue&type=style&index=0&id=01468952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01468952",
  null
  
)

export default component.exports